import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import enLang from "./locales/en/en.json";
import nlLang from "./locales/nl/nl.json";

// Temporary flag - set to true when Dutch translations are complete
const DUTCH_TRANSLATIONS_READY = false;

const resources = {
    en: {
        translation: enLang,
    },
    nl: {
        translation: nlLang,
    }
};

// Determine the default language based on the flag
const getDefaultLanguage = () => {
    if (!DUTCH_TRANSLATIONS_READY) {
        return "en"; // Force English when translations aren't ready
    }

    // Original logic when Dutch is ready
    return localStorage.getItem("selectedLanguage") ||
           (localStorage.getItem("language") === "Dutch" ? "nl" : "en") ||
           "nl";
};

const savedLanguage = getDefaultLanguage();

i18n
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: DUTCH_TRANSLATIONS_READY ? "nl" : "en", // Also update fallback
        lng: savedLanguage,
        interpolation: {
            escapeValue: false
        }
    });

// Listen for language changes and save to localStorage
i18n.on('languageChanged', (lng) => {
    localStorage.setItem("selectedLanguage", lng);
});

export default i18n;